import React from 'react';
import { motion } from 'framer-motion';
import { Ornament } from './Ornament';
export function ProductReveal() {
  return <section className="py-10 px-5 bg-navy-800/40 border-y border-gold-500/10" id="product" data-id="element-258">
      <div className="max-w-lg mx-auto text-center" data-id="element-259">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-260">
          <p className="text-gold-400 text-xs tracking-[0.2em] uppercase mb-3" data-id="element-261">
            Presentando
          </p>
          <h2 className="font-serif text-2xl sm:text-3xl text-cream-100 leading-tight mb-2" data-id="element-262">
            "Fui Llamada Para Este{' '}
            <span className="font-script text-4xl text-gold-400 lowercase inline-block -mb-2" data-id="element-263">
              momento
            </span>
            "
          </h2>
          <p className="text-cream-300/80 text-[13px] mt-3 mb-6" data-id="element-264">
            Devocional de 12 Días para Descubrir Tu Propósito en Dios a Través
            del Libro de Ester
            <br data-id="element-265" />
            <span className="opacity-60 mt-1 block" data-id="element-266">
              Por Odalia Morán Arévalo — Valor · Propósito · Fe
            </span>
          </p>

          <div className="relative w-full max-w-[200px] mx-auto mb-6" data-id="element-267">
            <div className="absolute inset-0 bg-gold-500/20 blur-3xl rounded-full" data-id="element-268"></div>
            <img src="https://cdn.magicpatterns.com/uploads/5Bhhee4ksftSF6w5EhaBER/WhatsApp_Image_2026-05-04_at_5.56.46_PM.jpg" alt="Libro Fui Llamada Para Este Momento" className="relative z-10 w-full h-auto rounded-sm shadow-2xl shadow-navy-900" data-id="element-269" />
          </div>

          <div className="space-y-3 text-[14px] sm:text-[15px] leading-relaxed text-cream-300/90 font-light text-left" data-id="element-270">
            <p className="font-medium text-cream-100 text-center" data-id="element-271">
              Este no es un devocional para leer y olvidar.
            </p>
            <p data-id="element-272">
              Es un proceso guiado de 12 días que te lleva de la mano, a través
              de la historia de Ester, para que puedas ver lo que quizás nunca
              habías podido ver:
            </p>
            <p className="text-center font-serif text-lg text-gold-400 italic py-1" data-id="element-273">
              Que Dios no improvisa contigo. Que Él forma. Posiciona. Y llama.
            </p>
            <p data-id="element-274">
              Y que tú — con todo lo que has vivido, todo lo que has sufrido,
              todo lo que has esperado — fuiste llamada para este momento.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}